import React from 'react';
import { Paper } from '@mui/material';

/**
 * PremiumCard
 * The main content container for premium pages.
 * Features rounded corners, subtle shadow, and a blue accent top border.
 */
const PremiumCard = ({ children, noPadding, ...props }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        padding: noPadding ? "0" : { xs: "24px", md: "48px" },
        border: "1px solid #edf2f7",
        borderTop: "6px solid #1976d2", // Accent Border
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025)",
        backgroundColor: "#ffffff",
        ...props.sx
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default PremiumCard;
